export const KURUM = 0;
export const FIRMA = 1;
export const MUHENDIS = 2;
export const ADMIN = 4;
